import BackgroundSection from "@/components/BackgroundSection/BackgroundSection";
import BgGlassmorphism from "@/components/BgGlassmorphism/BgGlassmorphism";
import SectionHero2 from "@/components/SectionHero/SectionHero2";
// import ContactUs from "../PageContact/ContactUs";
import { SectionGridFeatureAdboard } from "./SectionGripFeatureAdboard";
import { Helmet } from "react-helmet";
import _ from "lodash";
import { baseTitle } from "@/contains/contants";
import { setPageTitle } from "@/lib/utils";
import React, { useEffect } from "react";
import SectionGridAuthorBox from "@/components/SectionGridAuthorBox/SectionGridAuthorBox";
import FilterProvider from "./FiltersContext";
import { useWhiteLabel } from "@/context/WhiteLabelProvider";
import FAQ from "../BlogPage/FAQ";
import SectionSliderNewCategories from "@/components/SectionSliderNewCategories/SectionSliderNewCategories";
// import { SeoLinkSection } from "./SeoLinkSection";

function PageHome2() {
  const prevTitle = React.useRef<string|undefined>(undefined)
  const {whitelabelWorkspace} = useWhiteLabel();

  const currentTitle = _.startCase(window.location.pathname.substring(1))||"Home" +` | ${baseTitle}`
  
  useEffect(()=>{
    if(prevTitle.current !== currentTitle){
      setPageTitle(currentTitle)
      prevTitle.current = currentTitle
    }
  },[currentTitle])

  return (
    <div className="nc-PageHome2 relative overflow-hidden">
      <Helmet>
        <title>Online billboard booking | AdBoard Booking</title>
        <link rel="canonical" href="https://www.adboardbooking.com" />
      </Helmet>
      {/* GLASSMOPHIN */}
      <BgGlassmorphism />

      <div className="container relative space-y-10 mb-24 lg:space-y-8 lg:mb-28">
        {/* <SectionHero2 className="" /> */}
        <SectionHero2 className="pt-10 lg:pt-8 lg:pb-16" />
        
        <SectionSliderNewCategories
          categoryCardType="card3"
          heading="Suggestions for discovery"
          subHeading="Popular billboard locations that Adboard Booking recommends for you"
          sliderStyle="style1"
          uniqueClassName="PageHome_s2"
        />
        {/* SECTION */}
        <div className="relative pb-16 pt-8">
          <BackgroundSection className="bg-orange-50 dark:bg-black dark:bg-opacity-20 " />
          <FilterProvider>
            <SectionGridFeatureAdboard heading="Featured Premium Billboards"/>
          </FilterProvider>
        </div>
        
        {/* <BackgroundSection /> */}
        <div className="relative py-0">
          <div className={`xl:flex-grow xl:static xl:block`}>
            <FAQ/>
          </div>
          {/* <SectionMediaPlayer/> */}
          {/* <SectionClientSay uniqueClassName="client-say"/> */}
          {/* <PageHomeMap/> */}
        </div>
        {!whitelabelWorkspace &&
        <div className="relative py-16">
          <BackgroundSection className="bg-orange-50"/>
          <SectionGridAuthorBox />
        </div>
        } 
        {/* {!whitelabelWorkspace && <ContactUs/>} */}
        {/* <SeoLinkSection/> */}
        {/* SECTION */}
        
      </div>
    </div>
  );
}

export default PageHome2;
